import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BillingStore } from '@app/interfaces/billing-store.interface';
import { PolicyData } from '@app/interfaces/policy.interface';
import { BillingInfoService } from '@shared/services/billing-info.service';
import { PayerInfoService } from '../../../home/payer-info/payer-info.service';
import { BillingStoreService } from '../../../home/store/billing-store.service';
import { ThemingService } from '@shared/services/theming.service';
import { Theme } from '@shared/themes/default.theme';
import { constants } from '@app/@shared/constants';
import { AptFeatureFlagService } from '@archinsurance-da/arch-portal-tools';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  standalone: false,
})
export class SuccessComponent implements OnInit {
  downloading: boolean = false;
  cyberOfferEnabled: boolean = false;
  policyVerified: boolean = false;
  testing: boolean = true;
  redirectGuid: string;
  isCyberFlow: boolean = false;
  isProgressiveFlow: boolean = false;
  theme: Theme;

  constructor(
    private router: Router,
    private payerInfoService: PayerInfoService,
    private billingStoreService: BillingStoreService,
    private billingInfoService: BillingInfoService,
    private ffService: AptFeatureFlagService,
    private themeService: ThemingService
  ) {}

  successPayData: any;
  policyStore: BillingStore = {};

  ngOnInit(): void {
    this.successPayData = JSON.parse(sessionStorage.getItem('successPayData'));
    this.policyStore = this.billingStoreService.getBillingStore();

    this.redirectGuid = btoa(this.policyStore?.id);

    // Check if this is a cyber flow
    this.isCyberFlow = this.billingStoreService.isCyberFlow();

    this.ffService.flagChange.subscribe((flags: any) => {
      const cyberOfferEnabled = !flags.cyberOfferEnabled?.current
        ? flags.cyberOfferEnabled
        : flags.cyberOfferEnabled.current;
      // console.log('flags', flags);
      this.cyberOfferEnabled = cyberOfferEnabled;
    });

    // Check if this is a progressive flow by checking policyStore product
    // P44681 is Progressive producer
    const producer =
      this.policyStore?.policyData?.policy?.agentCd || this.getProducerFromProduct(this.policyStore?.product);

    if (producer === '44681') {
      this.isProgressiveFlow = true;
    } else if (producer === '43274') {
      this.isProgressiveFlow = false;
    } else if (producer === '43580') {
      this.isProgressiveFlow = false;
    } else if (producer === '18089') {
      this.isProgressiveFlow = false;
    }

    // Also subscribe to theme changes for updates
    // this.themeService.themeChange.subscribe((theme: Theme) => {
    //   this.theme = theme;
    //   console.log('Success - Theme Change:', theme);
    //   this.isProgressiveFlow = this.theme?.name === 'progressive';
    //   console.log('Success - Progressive Flow (from theme):', this.isProgressiveFlow);
    // });

    // console.log('ss', this.policyStore.redirectUrl);
    // console.log('this.policyStore', this.policyStore);

    if (this.policyStore.policyData.policy.quoteStatus !== 'ISS') {
      //if policy is not issued, try updating the policy before throwing them out
      this.billingInfoService
        .getPolicy(this.policyStore.id, this.policyStore.product, true)
        .subscribe((policyData: PolicyData) => {
          this.policyStore.policyData = policyData;
          // console.info(`%c Policy Number ${this.policyStore.policyData.policy.polNbr}`, 'font-weight: bold; color: #0057b8');
          this.billingStoreService.setBillingStore(this.policyStore);
          this.policyVerified = true;
        });
    } else {
      this.policyVerified = true;
    }

    // console.log('this.successPayData', this.successPayData);
  }
  goBackToBQX() {
    if (this.policyStore.redirectUrl && this.payerInfoService.validateUrl(atob(this.policyStore.redirectUrl))) {
      window.location.href = atob(this.policyStore.redirectUrl);
    }
  }
  goToPolicy() {
    this.router.navigate(['policy', this.policyStore.id]);
  }

  private getProducerFromProduct(product: string): string {
    // Map product type to producer ID
    if (product === 'ea') {
      return 'P43580'; // Canopy
    }
    return 'P43274'; // Default to Nationwide
  }

  downloadPolicy() {
    if (!this.downloading) {
      this.downloading = true;
      this.payerInfoService.downloadPolicy(this.policyStore).subscribe((resultBytes) => {
        var blob = new Blob([resultBytes], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `arch-policy-${this.policyStore.id}.pdf`;
        link.click();

        this.downloading = false;
      });
    }
  }

  navigateToCyber() {
    // console.log('Navigating to Cyber with redirectGuid:', this.redirectGuid);

    // Store cyber access eligibility in sessionStorage with policy ID and timestamp
    const cyberAccess = {
      policyId: this.policyStore?.id,
      timestamp: new Date().toISOString(),
      fromSuccessPage: true,
    };
    sessionStorage.setItem('cyberAccess', JSON.stringify(cyberAccess));

    this.router.navigate(['/direct/cyber', this.redirectGuid]);
  }
}
